import { dateCustom } from '../../../../components';
import { graficoCustom, paramsApi } from '../../../../helpers';
import api from '../../../../helpers/api';
import apiOld from '../../../../helpers/apiOld';
import apiV3 from '../../../../helpers/apiV3';
import { setFiltered } from '../../../../layout/redux/layoutActions';

export const setTotalAvaliacao = payload => ({
  type: 'INFO_GRAFICO_CSATCONCORRENTESREDES_TOTAL_AVALIACAO',
  payload
})


export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_CSATCONCORRENTESREDES',
  payload
})

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_CSATCONCORRENTESREDES',
  payload
})

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_CSATCONCORRENTESREDES',
})


export const setGraficoLoad = payload => ({
  type: 'LOAD_GRAFICO_CSATCONCORRENTESREDES',
  payload
})
export const setGrafico = payload => ({
  type: 'INFO_GRAFICO_CSATCONCORRENTESREDES',
  payload
})

export const setTooltipAtual = payload => ({
  type: 'INFO_TOOLTIP_ATUAL',
  payload
})

export const setTooltipAnterior = payload => ({
  type: 'INFO_TOOLTIP_ANTERIOR',
  payload
})

export const carregarGrafico = ({projetoID, empresaId, params, typeSelect, idioma1}) => {
  
  return dispatch => {
    dispatch(setGraficoLoad(true))
    let paramsUrl = paramsApi({
      ...params, 
      projetoId: projetoID,
      empresaId,
      idioma: idioma1,
    })
    apiV3.get(`/front/GetCsatConcorrentesRedes${paramsUrl}`)
    .then(result => {
      const resultado = graficoCustom(result.data, params)
      console.warn(result, 'carregarGrafico');
      dispatch([
        setGrafico(resultado),
        setTotalAvaliacao(result.data.totalAvaliacoes),
        setTooltipAtual(result.data.tooltipAtual),
        setTooltipAnterior(result.data.tooltipAnterior),
        setGraficoLoad(false)
      ])
    })
    .catch(err => {
      dispatch([
        setGrafico([]),
        setTotalAvaliacao(0),
        setGraficoLoad(false)
      ])
    });
  }
}

export const filterHandle = ({projetoID, empresaId, params, typeSelect, filtersProvisorio, idioma}) => {
  const paramsCustom = {...params, ciclo: params?.ciclo?.ano ? params.ciclo : filtersProvisorio.ciclo}
  return dispatch => {
    let paramsFilter = filtersCustom({params: paramsCustom, typeSelect})
    const idioma1 = idioma;
    dispatch(setGraficoLoad(true))
    dispatch([
      setFiltered(paramsCustom),
      carregarGrafico({projetoID, empresaId, params: paramsFilter, typeSelect, idioma1})
    ])
  }
}

export const filtersCustom = ({params, typeSelect}) => {
  let paramsFilter = {}
  if (typeSelect?.id === 'Ciclo') {
    if (params?.ciclo?.mesAno) {
      paramsFilter = {
        comparacao: params.compararCiclos.id === 'ativar'?true:false,
        intervalo: `${params.ciclo.ano}-${params.ciclo.mes}`,
      }
    }
  }
  if (typeSelect?.id === 'Data') {
    paramsFilter = {
      intervalo: `${dateCustom(params.dataInicial).data} ${dateCustom(params.dataFinal).data}`,
    }
  }
  return paramsFilter
}